<template>
  <g-master name="ocasionales"
            @params="paramsTable"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :modalFieldsSetup="master.modalFieldsSetup"
            :parentData="parentData"
            @action="masterAction"
            ref="masterComponent"
            modalWidth="90%"
  >
    <template slot="customButton">
      <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
    </template>
    <template slot="expandedRowRender" slot-scope="{text}">
      <template v-for="ve in master.valoresExpandidos">
        {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
      </template>
    </template>
    <template slot="masterModal" slot-scope="{record}">
      <a-row :gutter="[16,16]">
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Año')" v-bind="fiOptions">
            <a-select v-decorator="['year', { rules: [
                            { required: false},
                           ] }]" style="width: 100%">
              <a-select-option v-for="year_ in years" :key="year_">
                {{ year_ }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Mes')" v-bind="fiOptions">
            <a-select v-decorator="['month', { rules: [
                            { required: false},
                           ] }]" style="width: 100%">
              <a-select-option v-for="month_ in months_name" :key="month_.value">
                {{ month_.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col v-bind="colOptions">
          <g-dropdown :label="$t('Periodo')"
                      :formItemConfig="fiOptions"
                      endpoint="hierarchy_lookup"
                      :decorator="['period', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                      :params="period_request">
          </g-dropdown>
        </a-col>
        <a-col v-bind="colOptions">
          <g-dropdown :label="$t('Estado')"
                      :formItemConfig="fiOptions"
                      endpoint="hierarchy_lookup"
                      :decorator="['loan_status', { rules: [{ required: false, message: 'Valor requerido' }]}]"
                      :params="status"
          >
          </g-dropdown>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Fecha pago')" v-bind="fiOptions">
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-decorator="['payment_date', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <g-dropdown :label="$t('Proceso')"
                      :formItemConfig="fiOptions"
                      endpoint="hierarchy_lookup"
                      :decorator="['prc', { rules: [{ required: false, message: 'Valor requerido' }]}]"
                      :params="procesos_liquidacion"
          >
          </g-dropdown>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Saldo inicial')">
            <a-input-number style="width: 100%" step="1"
                            v-decorator="['ammount_initial', { rules: [{ required: false, message: 'Valor requerido' }]}]"
                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            :parser="value => value.replace(/\$\s?|(,*)/g, '')"
            ></a-input-number>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Pago programado')">
            <a-input-number style="width: 100%" step="1"
                            v-decorator="['ammount', { rules: [{ required: false, message: 'Valor requerido' }]}]"
                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            :parser="value => value.replace(/\$\s?|(,*)/g, '')"
            ></a-input-number>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Capital')">
            <a-input-number style="width: 100%" step="1"
                            v-decorator="['capital', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            :parser="value => value.replace(/\$\s?|(,*)/g, '')"
            ></a-input-number>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Interes')">
            <a-input-number style="width: 100%" step="1"
                            v-decorator="['interest', { rules: [{ required: false, message: 'Valor requerido' }] }]"
            ></a-input-number>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Saldo final')">
            <a-input-number style="width: 100%" step="1"
                            v-decorator="['ammount_end', { rules: [{ required: false, message: 'Valor requerido' }]}]"
                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            :parser="value => value.replace(/\$\s?|(,*)/g, '')"
            ></a-input-number>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Interes acomulado')">
            <a-input-number style="width: 100%" step="1"
                            v-decorator="['accumulated_interest', { rules: [{ required: false, message: 'Valor requerido' }] }]"
            ></a-input-number>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <g-dropdown endpoint="hierarchy_lookup"
                      style="width: 100%"
                      :label="$t('Moneda')"
                      :formItemConfig="fiOptions"
                      :decorator="['currency', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                      :params="code_currency">
          </g-dropdown>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Fecha Liquidación')" v-bind="fiOptions">
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-decorator="['settlement_date', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
          </a-form-item>
        </a-col>
      </a-row>
    </template>
  </g-master>
</template>
<script>
  import JsUtils from '@/util/JsUtils'

  export default {
    props: ['id_loans'],
    data () {
      return {
        procesos_liquidacion: {
          h_lookup_type: 'PROCESOS_LIQUIDACION',
          use_code: true,
          concat_text_code: true
        },
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        months_name: [
          {name: 'Enero', value: '1'},
          {name: 'Febrero', value: '2'},
          {name: 'Marzo', value: '3'},
          {name: 'Abril', value: '4'},
          {name: 'Mayo', value: '5'},
          {name: 'Junio', value: '6'},
          {name: 'Julio', value: '7'},
          {name: 'Agosto', value: '8'},
          {name: 'Septiembre', value: '9'},
          {name: 'Octubre', value: '10'},
          {name: 'Noviembre', value: '11'},
          {name: 'Diciembre', value: '12'}
        ],
        yearToday: parseInt(moment().format('YYYY')),
        years: [],
        pliq: {
          h_lookup_type: 'PROCESOS_LIQUIDACION',
          use_code: true,
          concat_text_code: true
        },
        code_currency: {
          h_lookup_type: 'MONEDA',
          use_code: true
        },
        status: {
          h_lookup_type: 'STATUS_LOANS',
          use_code: true
        },
        colOptions: {xs: 24, sm: 8},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          valoresExpandidos: [
            {label: 'Interes acomulado', column: 'accumulated_interest'},
            {label: 'Proceso', column: 'prc'},
            {label: 'Fecha liquidacion', column: 'settlement_date_desc'},
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado', column: 'modified_on'}
          ],
          endpoint: 'amortization_loan',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Estado', dataIndex: 'loan_status', sorter: true},
              {title: 'Fecha de pago', dataIndex: 'payment_date_desc', sorter: true},
              {title: 'Año', dataIndex: 'year', sorter: true},
              {title: 'Mes', dataIndex: 'month', sorter: true},
              {title: 'Periodo', dataIndex: 'period', sorter: true},
              {title: 'Proceso', dataIndex: 'prc', sorter: true},
              {title: 'Saldo inicial', dataIndex: 'ammount_initial', sorter: true, align: 'right'},
              {title: 'Saldo final', dataIndex: 'ammount_end', sorter: true, align: 'right'},
              {title: 'Capital', dataIndex: 'capital', sorter: true},
              {title: 'Moneda', dataIndex: 'currency', sorter: true},
              {title: 'Pago programado', dataIndex: 'ammount'},
              {title: 'Interes', dataIndex: 'interest'}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_loans'},
            {name: 'accumulated_interest'},
            {name: 'ammount'},
            {name: 'ammount_end'},
            {name: 'ammount_initial'},
            {name: 'capital'},
            {name: 'currency'},
            {name: 'interest'},
            {name: 'loan_status'},
            {name: 'month'},
            {name: 'payment_date'},
            {name: 'period'},
            {name: 'prc'},
            {name: 'settlement_date'},
            {name: 'year'}
          ]
        },
        endpointExcel: 'amortization_loan_/downloadExcel',
        fileNameExcel: 'PlanDeAmortizacion',
        paramsT: {}
      }
    },
    mounted () {
      this.yearsSelect()
    },
    methods: {
      yearsSelect () {
        for (let i = this.yearToday - 1; i <= (this.yearToday + 5); i++) {
          this.years.push(i)
        }
      },
      masterAction (action) {
        switch (action.action) {
          case 'fieldsChange':
            if (Object.keys(action.changedFields).length > 1) {
              break
            }
            if (!JsUtils.isEmpty(action.changedFields.payment_date)) {
              if (JsUtils.isEmpty(action.changedFields.payment_date.value)) {
                this.$refs.masterComponent.modal.form.setFieldsValue({
                  payment_date: null
                })
              } else {
                let endDate = new Date(action.changedFields.payment_date.value)
                let month = ('0' + (endDate.getMonth() + 1)).slice(-2)
                let year = endDate.getFullYear()
                this.$refs.masterComponent.modal.form.setFieldsValue({
                  year: year,
                  month: month
                })
              }
            }
            break
        }
      },
      loadData () {
        this.$refs.masterComponent.$refs.datatable.loadData()
      },
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      parentData () {
        return {
          id_loans: this.id_loans
        }
      },
      paramsExcel () {
        let columsDetail = this.master.valoresExpandidos.map(item => {
          item['title'] = item['label']
          item['dataIndex'] = item['column']
          return item
        })
        return {...this.paramsT, columns: this.master.tableSetup.columns.concat(columsDetail), ...this.parentData}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/CreditosAmortizacion.vue